module.exports = __webpack_public_path__ + "img/inputFile.1e800d87.svg";